import { DynaVault } from '../../../api/DynaVaultsAPI';
import { TOKENS } from 'utils/constants/tokens';
import { getVaultAPY } from 'structure/pv2/vault/utils/vault';
import { mapAsUSDC } from 'structure/capital-manager/tokens';

export const findVaultListByDepositToken = (
  originalVaultList: DynaVault[],
  tokenAddress: `0x${string}`,
  tokenChainId: number
) => {
  if (originalVaultList.length === 0) return [];

  const vaultList = originalVaultList.filter((vault) => {
    if (vault.isClosed || vault.chainId !== tokenChainId) {
      return false;
    }

    const isDepositToken =
      vault.depositToken.toLowerCase() === tokenAddress.toLowerCase();

    if (isDepositToken) {
      return true;
    }

    const mappedAsUSDC = mapAsUSDC.some(
      (mappedToken) => mappedToken.toLowerCase() === tokenAddress.toLowerCase()
    );

    // if deposit token is USDC
    if (
      mappedAsUSDC &&
      vault.depositToken.toLowerCase() ===
        TOKENS.BASE_L2.USDC.address.toLowerCase()
    ) {
      return mapAsUSDC.some(
        (mappedToken) =>
          mappedToken.toLowerCase() === tokenAddress.toLowerCase()
      );
    }

    if (vault.tokenAllocation) {
      return vault.tokenAllocation.some(
        (allocationToken) =>
          allocationToken.token.address.toLowerCase() ===
          tokenAddress.toLowerCase()
      );
    }

    return false;
  });

  return vaultList.sort((vaultA, vaultB) => {
    return getVaultAPY(vaultA) > getVaultAPY(vaultB) ? -1 : 1;
  });
};
